import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@app/auth/services/authentication/auth.service";
import { Role } from "@app/core/models/Role";
import { FeedbackType } from "@app/shared/models/feedbackType";
import { SpinnerService } from "@app/shared/services/spinner/spinner.service";
import { SliderComponent } from "@app/shared/slider/slider.component";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { heroEye, heroEyeSlash } from "@ng-icons/heroicons/outline";

import { FeedbackService } from "../../../shared/services/feedback/feedback.service";

@Component({
  selector: "app-reset-password",
  standalone: true,
  imports: [NgIconComponent, FormsModule, SliderComponent],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.scss",
  viewProviders: [provideIcons({ heroEye, heroEyeSlash })],
})
export class ResetPasswordComponent implements OnInit {
  showPassword = [false, false];
  inputType = ["password", "password"];
  password = "";
  confirmPassword = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private auth: AuthService,
    private spinner: SpinnerService,
    private feedback: FeedbackService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const { token } = this.activatedRoute.snapshot.queryParams;
    this.auth
      .validatePasswordToken(token)
      .subscribe({
        next: () => {},
        error: (error: string) => {
          const sentences = error.split(",").map((sentence) => sentence.trim());
          const result = sentences.join(" ");

          this.feedback.openModal(FeedbackType.ERROR, "Oops!", result);
        },
      })
      .add(() => {
        this.spinner.hide();
      });
  }

  toggleVisibility(index: number) {
    this.showPassword[index] = !this.showPassword[index];
    this.inputType[index] = this.showPassword[index] ? "text" : "password";
  }

  onSubmit() {
    const { token } = this.activatedRoute.snapshot.queryParams;
    this.auth
      .updatePassword(this.password, token)
      .subscribe({
        next: (res) => {
          if (res.roleName === Role.INSTRUMENT_TECHNICIAN) {
            this.router.navigate(["password/reset/success"]);
          } else {
            this.feedback
              .openModal(
                FeedbackType.SUCCESS,
                "Sucesso",
                "Senha alterada com sucesso"
              )
              .result.then((result) => {
                if (result) {
                  this.router.navigate(["/login"]);
                }
              });
          }
        },
        error: (error: string) => {
          const sentences = error.split(",").map((sentence) => sentence.trim());
          const result = sentences.join(" ");

          this.feedback.openModal(FeedbackType.ERROR, "Oops!", result);
        },
      })
      .add(() => {
        this.spinner.hide();
      });
  }

  test() {
    this.feedback.openModal(FeedbackType.INSTRUMENT_TECHNICIAN, "Sucesso", "");
  }
}
